import { createRelationalReportFromBaseReport } from 'reporting-snowflake/relational/utils/report-utils';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Button } from 'foundations-components/transitional/components/Button';
import { applyConditionalFormattingToColumn, updateSnowflakeReportEncodingWithConditionalFormatting } from '../utils';
import { AddIcon } from 'foundations-assets';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSnowflakeReportUpdater } from 'reporting-snowflake/relational/updaters/report/use-snowflake-updater';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SnowflakeConditionalFormattingReapply = ({
  report,
  onChange,
  onReapplyToColumn,
  selectedColumnName
}) => {
  var _snowflakeReport$visu;
  const snowflakeReport = createRelationalReportFromBaseReport(report);
  const snowflakeUpdater = useSnowflakeReportUpdater(snowflakeReport);
  const encodings = (_snowflakeReport$visu = snowflakeReport.visual) === null || _snowflakeReport$visu === void 0 ? void 0 : _snowflakeReport$visu.encodings;
  const encoding = encodings.get('columns').find(encodedColumn => encodedColumn.column === selectedColumnName);
  const toIndex = encodings.get('columns').indexOf(encoding);
  return /*#__PURE__*/_jsx(FormControl, {
    children: /*#__PURE__*/_jsxs(Button, {
      use: "link",
      onClick: () => {
        onReapplyToColumn();
        const nextEncoding = applyConditionalFormattingToColumn(snowflakeReport, selectedColumnName);
        const nextReport = updateSnowflakeReportEncodingWithConditionalFormatting({
          updatedEncoding: nextEncoding,
          toIndex,
          snowflakeUpdater
        });
        if (nextReport) {
          onChange(nextReport);
        }
      },
      children: [/*#__PURE__*/_jsx(AddIcon, {
        size: "300"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "report-customization-components.customization-components.conditional-formatting.add-button"
      })]
    })
  });
};
export default SnowflakeConditionalFormattingReapply;